import EditablePdf from './EditablePdf'

export default EditablePdf
